<template>
  <!-- <div :class="isios === 1?'ios':'android'"> -->
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <transition-group :name="transitionName">
    </transition-group> -->
  </div>
</template>

<script>
  export default {
    data() {
      return{
        isios:0,
        transitionName:'',
      }
    },
    methods: {
      
    },
    watch: {//使用watch 监听$router的变化
      $route(to, from) {
        //如果to索引大于from索引,判断为前进状态,反之则为后退状态
        if(to.meta.index > from.meta.index){
        //设置动画名称
          this.transitionName = 'slide-left';
        }else{
          this.transitionName = 'slide-right';
        }
      }
    },
    created () {
      
    },
    mounted () {
      
    }
  }
</script>


<style lang="less">
  .van-image-preview__index {
    position: absolute;
    top: 90px !important;
    left: 50%;
  }
  .van-dialog__message {
    font-weight: 600;
    font-size: 17px !important;
  }
  .android{
    width: 100%;
    height: 100%;
    .slide-right-enter-active,
    .slide-right-leave-active,
    .slide-left-enter-active,
    .slide-left-leave-active {
      will-change: transform;
      transition: all 500ms;
      position: absolute;
      .header,.van-nav-bar{top: -46px !important;}
    }
     
  } 
  .ios{
    width: 100%;
    height: 100%;
    .slide-right-enter-active,
    .slide-right-leave-active,
    .slide-left-enter-active,
    .slide-left-leave-active {
      will-change: transform;
      transition: all 500ms;
      position: absolute;
      .header,.van-nav-bar{top: -69px !important;}
    }
  }
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .ios{
      .slide-right-enter-active,
      .slide-right-leave-active,
      .slide-left-enter-active,
      .slide-left-leave-active {
        will-change: transform;
        transition: all 500ms;
        position: absolute;
        .header,.van-nav-bar{top: -93px !important;}
      }
    }
  }
    
  .slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  .slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  .slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  .slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .android {
    padding-top: 46px;
    .header{
      position: fixed;
      top: 0;
      left: 0;
    }
    .home_hd{margin-top: -46px;}
    .van-nav-bar{
      position: fixed;
      top:0;
      left: 0;
      height: 46px;
      line-height: 46px;
      width: 100%;
      z-index: 9999 !important;
    }
  }

  .ios {
    padding-top: 69px; 
    .header {
      position: fixed;
      top: 0;
      left: 0;
      padding-top: 23px;
      height: 69px !important;
    }
    .home_hd{margin-top: -69px;padding-top: 23px;height: 123px !important;}
    .van-nav-bar{
      position: fixed;
      top: 0;
      left: 0;
      padding-top: 23px;
      height: 69px !important;
      width: 100%;
      z-index: 9999 !important;
    }
  }

  /*适配 iphone X*/
  //iphoneX、iphoneXs

  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .ios {
      padding-top: 93px;
      .header {
        position: fixed;
        top: 0;
        left: 0;
        padding-top: 47px;
        height: 93px !important;
        width: 100%;
      }
      .home_hd{margin-top: -93px;padding-top: 47px;height: 147px !important;}
      .van-nav-bar {
        position: fixed;
        top: 0;
        left: 0;
        padding-top: 47px;
        height: 93px !important;
        width: 100%;
        z-index: 9999 !important;
      }
    }
  }

  //iphone Xs Max
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:3) {
  }
  //iphone XR
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:2) {
  }
  //横屏
  @media all and (orientation : landscape) { 
  } 
  //竖屏
  @media all and (orientation : portrait){ 
  } 

</style>
